import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-multiple-search',
  templateUrl: './multiple-search.component.html',
  styleUrls: ['./multiple-search.component.scss'],
})
export class MultipleSearchComponent implements OnInit {
  @Input() multiArray: any[] = [];
  @Output() onCancel = new EventEmitter<void>();
  @Output() onSearch = new EventEmitter<any>();

  ngOnInit() {
    console.log(this.multiArray);
  }
}
